import { useSelector } from 'react-redux';
import { player } from 'src/client/player';
import { playerStatuses } from 'src/common/constants/playerStatuses';
import { useStoreSelector } from '../providers';
import { selectIsMobile } from '../selectors/app';

const playerManagerPlayerAction = (_, __, guideItem, skipPreroll) =>
  player.onClick(guideItem, { skipPreroll });

/**
 * Pages can render hundreds of components wrapped with this decorator (one per tile), so each one
 * selects only the player state that concerns its own guide item. A tune or a status change then
 * re-renders the tiles that start or stop being in sync with the player, not every tile on the page.
 */
export function usePlayerSyncProps(guideItem) {
  const playGuideId = guideItem?.actions?.play?.guideId;
  const isSyncedWithPlayer = useStoreSelector(
    'playerStore',
    (state) => !!playGuideId && playGuideId === state.currentGuideItem?.playableGuideId,
  );
  const syncedPlayerStatus = useStoreSelector('playerStore', (state) =>
    isSyncedWithPlayer ? state.playerStatus : playerStatuses.idle,
  );
  // Only the synced item shows a pause or stop icon, so the others don't need the stream's details.
  const canScrub = useStoreSelector(
    'playerStore',
    (state) => !isSyncedWithPlayer || !state.metadata?.isUnboundedStream,
  );

  return { isSyncedWithPlayer, syncedPlayerStatus, canScrub };
}

export default function connectWithPlayer(MyComponent) {
  function ConnectWithPlayer(props) {
    const isMobile = useSelector(selectIsMobile);
    const playerSyncProps = usePlayerSyncProps(props.guideItem);

    return (
      <MyComponent
        {...props}
        {...playerSyncProps}
        isMobile={isMobile}
        syncedPlayerAction={playerManagerPlayerAction}
      />
    );
  }

  ConnectWithPlayer.displayName = `ConnectWithPlayer(${MyComponent.displayName || MyComponent.name})`;

  return ConnectWithPlayer;
}
